// Cookies
function createCookie(cookieName,cookieValue,daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
}

function accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for(var i=0; i<allCookieArray.length; i++) {
        var temp = allCookieArray[i].trim();
        if (temp.indexOf(name)==0)
        return temp.substring(name.length,temp.length);
    }
    return "";
}

function setCookieCloseBox(cookieName) {
    createCookie(cookieNaam, 'closed', days); // create cookie 
    document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
    document.body.classList.remove('newsletterbox-active'); // hide newsletter box
}

// Newsletter
function newsletterPopup() {
    var newsletterBox = document.getElementById("newsletterbox");
    if (newsletterBox) {
        var cookieNaam = "newspopup";
        var isCookie = accessCookie(cookieNaam);

        var days = newsletterBox.dataset.expire; // Get days from data-expire
        var cdown = newsletterBox.dataset.cdown; // Get count down from data-cdown
        var tnx = newsletterBox.dataset.thanks; // Get thanks from data-tnx
        var err = newsletterBox.dataset.err; // Get error from data-err
        var mail = newsletterBox.dataset.mail; // Get mail from data-mail

        if (days === undefined) { var days = 7; }
        if (cdown === undefined) { var cdown = 30000; }
        if (tnx === undefined) { var tnx = "Thanks for signing up!"; }
        if (err === undefined) { var err = "There was an error in submitting the form."; }
        if (mail === undefined) { var mail = "Please fill in your email address."; }

        // Countdown: show after X sec
        function countDownr(event) {
            setTimeout(function() {
                document.body.classList.add('newsletter-active'); // show newsletter box
            }, cdown);
        }

        // Check if user tries to leave from top
        function userLeave(event) {
            if(event.clientY <= 0) {
                document.body.classList.add('newsletter-active'); // show newsletter box
            }
        }

        // If cookie is not set show newsletter box
        if(isCookie !== 'closed') {
            countDownr(); // start countdown
        }

        // If is challenge page
        var challengeUrl = window.location.origin +'/challenge#contact_form';
        var currentUrl = window.location;
        if(currentUrl == challengeUrl) {
            document.getElementById('newsletterbox').style.display = 'none';
        }

        // Set cookie for "X" days and close newsletter box
        function setCookieNclose() {
            createCookie(cookieNaam, 'closed', days); // create cookie 
            document.body.removeEventListener("mouseleave", userLeave); // prevent box from reappearing
            document.body.classList.remove('newsletter-active'); // hide newsletter box
        }

        // On click Set cookie for "X" days and close newsletter box
        document.getElementById('closenewsletter').addEventListener("click", function() {
            setCookieNclose();
        });

        // Newsletter submit thru AJAX
        // TODO: convert in Vanilla JS
        $('form.contact-form').submit( function(){
            $('p.msg.is-green, p.msg.is-red').remove();
            if($(this).find('input[type="email"]').val() !== '') {
                var data = $(this).serialize();
                $.ajax({
                    type: "POST",
                    url: "/contact#contact_form",
                    data: data,
                    crossDomain: true,
                    success: function(response, textStatus, xhr) {
                        $('.contact-form').append('<p class="msg is-green">'+tnx+'</p>');
                        setTimeout(function(){ 
                            setCookieNclose(); 
                        }, 3000);
                    }, error: function(XMLHttpRequest, textStatus, errorThrown) {
                        $('.contact-form').append('<p class="msg is-red">'+err+'</p>');
                    }
                });

                // If customer is challenged
                if(response.status == 429) {
                    var challengeUrl = window.location.origin +'/challenge#'
                    window.location = challengeUrl
                }
            } else {
                $(this).append('<p class="msg is-red">'+mail+'</p>');
            }
            return false;
        });

        // When customer is back from challenge
        var checkURL = ["?customer_posted=true", "?contact%5Btags%5D=newsletter&form_type=customer"];
        for (var i = 0; i < checkURL.length; i++) {
            if(window.location.href.indexOf(checkURL[i]) > -1) {
                // Show newsletter box
                document.body.classList.add('newsletter-active');
                setTimeout(function(){
                    setCookieNclose(); 
                }, 5000);
            }
        }
    }
    
}
// Toggle Body Class
    let toggleBodyClass = function(arg) {
        document.body.classList.toggle(arg);
      if(arg == 'open-menu') {
        document.body.classList.remove("sub-menu-open");
        let all_sub_elem = document.querySelectorAll('.submenu');
      if(all_sub_elem){
        all_sub_elem.forEach(el => {
  el.classList.remove('active');
});
      }
    }
    }
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function getSetVh() {
    let vh = window.innerHeight * 0.01;
    document.body.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', () => {
    getSetVh();
});

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        let elArray = document.querySelectorAll(qSelectors);
        elArray.forEach(function(e) {
            e.addEventListener("click", function() {
                toggleBodyClass(bodyClass);
            });
        });
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu');
    
    }
// Menu
    let toggleSearch = function() { 
        
    }
// Cart
    let toggleCart = function() {
       // toggleClass('.carto, .cartc', 'open-cart');

        const clsbtn = document.querySelector('.cartc');
        if (clsbtn) {
            clsbtn.addEventListener('click', () => {
                document.body.classList.remove('hideheader');
            });
        }
    }

// Dropdown menu header
function dropdownMenu() {
    const detailsElements = document.querySelectorAll("details.lv1");

    function handleClickOnDetails() {
      // close all details
      let detailsOpened = document.querySelectorAll("details[open].lv1");

      for (const item of detailsOpened) {
        if (this != item) {
          item.removeAttribute("open");
        }
      }
    }

    detailsElements.forEach(function (item) {
      item.addEventListener("click", handleClickOnDetails);
    });
}

// Close <details> when you click outside
var details = [...document.querySelectorAll('details')];
document.addEventListener('click', function(e) { 
    if (!details.some(f => f.contains(e.target))) { 
        details.forEach(f => (f.parentElement?.classList.contains('filterBlock')) ? '' : f.removeAttribute('open')); 
    } else { 
        details.forEach(f => (!f.contains(e.target) && !f.parentElement?.classList.contains('filterBlock')) ? f.removeAttribute('open') : '') 
    } 
});

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
function ajaxCart(obj , showloader) {
    console.log(obj);
  
    // Show loading feedback
    if(!showloader){
    obj.classList.add('loading');
    }
    // on cart request success
    $(document).ajaxSuccess(function(event, jqxhr, settings) {
      console.log(jqxhr);
      
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
        
            // on cart request complete (just in case)
            $(document).on('cart.requestComplete', function(event, cart) {
                // Update # of items in cart  
               
                
                var sel_v =  $(obj).closest('.product-grid-listing').find(".selected_variant");
             
               
                var sel_v_id =  sel_v.val();
                console.log(sel_v_id);
                var popup_item = cart.items.filter(item => item.variant_id == sel_v_id);
                console.log(popup_item);
                document.getElementById('counter').setAttribute('data-count', cart.item_count);
               $(obj).closest('.product-grid-listing').find(".selected_variant").val("");
              $(obj).closest('.product-grid-listing').find(".mob-sizes li").removeClass("active");
               $(obj).closest('.product-grid-listing').find(".size-option li").removeClass("active");
               
                // Open cart
              //  document.body.classList.add('open-cart');
             //   document.body.classList.add('hideheader');
               if(popup_item.length){
                show_popup(popup_item[0] , cart.item_count);
               }
                // Remove loading feedback
                obj.classList.remove('loading');
            });
        }
    });

    // on cart request error
    $(document).ajaxError(function(event, jqxhr, settings) {
        if (settings.url == '/cart/add.js' || settings.url == '/cart/change.js') {
           $(obj).closest('.product-grid-listing').find(".selected_variant").val("");
           $(obj).closest('.product-grid-listing').find(".mob-sizes li").removeClass("active");
               $(obj).closest('.product-grid-listing').find(".size-option li").removeClass("active");
            obj.classList.remove('loading'); // Remove loading feedback
            console.log(jqxhr.responseJSON);
            alert(jqxhr.responseJSON.description);
            event.stopImmediatePropagation();
        }
    });
}

// Update # of items in cart
/*
$(document).on('cart.requestComplete', function(event, cart) {
    document.getElementById('counter').setAttribute('data-count', cart.item_count);
});

*/
function show_popup(added_item , total_items) {
  console.log(added_item);
  $('.cart-notification-wrapper').remove();    
  var popup_html = `<div class="cart-notification-wrapper active"> <div class="cart-notification"> <div class="cn-header"> <h2 class="cn-heading"> <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-checkmark" viewBox="0 0 64 64"> <path d="M49.3 19.3L28.6 39.9 17.1 28.8l-2.8 2.9 14.4 13.8 23.4-23.4z"></path> </svg>Added To Cart </h2> <span class="cn-close"> <svg fill="#000000" stroke="#000000" style="width:10px; height:10px;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 16.8 16.8"> <path fill="#000000" d="M16.8 1.5L15.4.1 8.4 7l-7-7L0 1.4l7 7-7 7 1.4 1.4 7-7 7 7 1.4-1.4-7-7z"></path> </svg> </span> </div> <div class="cn-product"> <div class="cn-product-image"> <img src="${added_item.featured_image.url}" alt="" loading="lazy" width="70" height="70"> </div> <div class="cn-details"> <h3 class="cn-product-name">${added_item.product_title}</h3> <p class="cn-variant-name">${added_item.variant_title}</p> <p class="cn-product-price"><span class="money">${Shopify.formatMoney(added_item.final_line_price)} </span> </p> </div> </div>  <div class="cn-links"> <a href="/cart" class="cn-btn cn-btn-view-cart" id="cn-button">View Cart (${total_items})</a> <a class="cn-btn cn-btn-close">Continue Shopping</a> <a href="/checkout" class="cn-btn cn-btn-checkout" name="checkout">Checkout</a> </div> </form> </div> </div>`;
  console.log(popup_html);
  $("#header").after(popup_html);
}
$(document).on('click','.cn-close , .cn-btn-close ' , function() {
//$(this).closest('.cart-notification-wrapper').remove();    
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    dropdownMenu(); // Dropdown menu
    newsletterPopup(); // Newsletter popup
    toggleMenu(); // toggle Menu
    toggleSearch(); // toggle Search
    toggleCart(); // toggle Cart
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })